/**
 * Entity selection model for entity selection event from iFrame.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class EntitySelection {
    entityId: number;
    entityType: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/entity-selection.model.ts